/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Company_Overview_Message_Balance_InfoInputs */

const es_admin_company_overview_message_balance_info = /** @type {(inputs: Admin_Company_Overview_Message_Balance_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mensajes que aún podés enviar al chat de Nexy. Un mensaje incluye una pregunta del usuario y la respuesta de Nexy.`)
};

const en_admin_company_overview_message_balance_info = /** @type {(inputs: Admin_Company_Overview_Message_Balance_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Messages you can still send to Nexy. One message includes a user question and Nexy’s response.`)
};

/**
* | output |
* | --- |
* | "Messages you can still send to Nexy. One message includes a user question and Nexy’s response." |
*
* @param {Admin_Company_Overview_Message_Balance_InfoInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_company_overview_message_balance_info = /** @type {((inputs?: Admin_Company_Overview_Message_Balance_InfoInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Company_Overview_Message_Balance_InfoInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_company_overview_message_balance_info(inputs)
	return en_admin_company_overview_message_balance_info(inputs)
});
export { admin_company_overview_message_balance_info as "admin.company_overview.message_balance_info" }